/* rhoneprints: quiet generated sounds (swish, click, static, blips, kaching). a first-time visitor starts off; their first click, tap or key press turns it on. once on, it stays on across refreshes and pages until they switch it off (the browser still needs one click or key press per page load before audio can play). */
(function () {
  'use strict';
  var KEY = 'gl-sound';
  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  var on = saved === '1';
  var autoOn = saved === null;
  var AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return;
  function save(v) { try { localStorage.setItem(KEY, v ? '1' : '0'); } catch (x) {} }
  var coarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

  var ctx = null, master = null, noiseBuf = null;
  function ensure() {
    if (!ctx) {
      ctx = new AC();
      master = ctx.createGain();
      master.gain.value = 0.6;
      master.connect(ctx.destination);
      noiseBuf = ctx.createBuffer(1, ctx.sampleRate, ctx.sampleRate);
      var d = noiseBuf.getChannelData(0);
      for (var i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
      /* iOS wants a sound started inside the touch to unlock the context: a one-sample silent blip */
      try {
        var ub = ctx.createBuffer(1, 1, 22050), us = ctx.createBufferSource();
        us.buffer = ub; us.connect(ctx.destination); us.start(0);
      } catch (e) {}
    }
    if (ctx.state !== 'running' && ctx.state !== 'closed') ctx.resume();
    return ctx.state !== 'closed';
  }
  function rnd(a, b) { return a + Math.random() * (b - a); }

  /* phones: a silent looping clip tells iOS this page is "playing audio", which keeps the sounds audible even with the ring/silent switch on silent */
  var silent = null;
  function silentWav() {
    var n = 4000, b = new Uint8Array(44 + n * 2), v = new DataView(b.buffer);
    function s(o, t) { for (var i = 0; i < t.length; i++) v.setUint8(o + i, t.charCodeAt(i)); }
    s(0, 'RIFF'); v.setUint32(4, 36 + n * 2, true); s(8, 'WAVEfmt '); v.setUint32(16, 16, true);
    v.setUint16(20, 1, true); v.setUint16(22, 1, true); v.setUint32(24, 8000, true); v.setUint32(28, 16000, true);
    v.setUint16(32, 2, true); v.setUint16(34, 16, true); s(36, 'data'); v.setUint32(40, n * 2, true);
    var bin = '';
    for (var i = 0; i < b.length; i++) bin += String.fromCharCode(b[i]);
    return 'data:audio/wav;base64,' + btoa(bin);
  }
  function unlockPhone() {
    if (!coarse) return;
    try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (e) {}
    try {
      if (!silent) {
        silent = new Audio(silentWav());
        silent.loop = true;
        silent.setAttribute('playsinline', '');
        silent.setAttribute('aria-hidden', 'true');
      }
      var p = silent.play();
      if (p && p.catch) p.catch(function () {});
    } catch (e) {}
  }
  function lullPhone() { try { if (silent) silent.pause(); } catch (e) {} }

  function noise(dur, type, f0, f1, q, vol) {
    var src = ctx.createBufferSource();
    src.buffer = noiseBuf;
    src.loop = true;
    var f = ctx.createBiquadFilter();
    f.type = type;
    var t = ctx.currentTime;
    f.frequency.setValueAtTime(f0, t);
    f.frequency.exponentialRampToValueAtTime(f1, t + dur);
    f.Q.value = q;
    var g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.linearRampToValueAtTime(vol, t + dur * 0.35);
    g.gain.linearRampToValueAtTime(0.0001, t + dur);
    src.connect(f); f.connect(g); g.connect(master);
    src.start(t, Math.random() * 0.5);
    src.stop(t + dur + 0.02);
  }
  function tone(freq0, freq1, dur, type, vol) {
    var o = ctx.createOscillator();
    o.type = type;
    var t = ctx.currentTime;
    o.frequency.setValueAtTime(freq0, t);
    o.frequency.exponentialRampToValueAtTime(Math.max(30, freq1), t + dur);
    var g = ctx.createGain();
    g.gain.setValueAtTime(vol, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g); g.connect(master);
    o.start(t); o.stop(t + dur + 0.02);
  }

  function swish(v) { if (on && ensure()) noise(0.13, 'bandpass', rnd(500, 800), rnd(1200, 2000), 0.9, v); }
  function click() {
    if (!on || !ensure()) return;
    tone(1300, 320, 0.06, 'square', 0.018);
    noise(0.03, 'highpass', 3500, 6000, 0.7, 0.014);
  }
  function blip() {
    if (!on || !ensure()) return;
    var f = [660, 880, 990, 1320, 1760][Math.floor(Math.random() * 5)];
    tone(f, f, rnd(0.035, 0.07), 'triangle', 0.015);
    if (Math.random() < 0.4) setTimeout(function () { if (on) tone(f * 1.5, f * 1.5, 0.04, 'triangle', 0.011); }, 80);
  }
  function stat() {
    if (!on || !ensure()) return;
    var n = 2 + Math.floor(Math.random() * 3);
    for (var i = 0; i < n; i++) {
      (function (k) { setTimeout(function () { if (on && ctx) noise(rnd(0.03, 0.07), 'highpass', rnd(2500, 5000), rnd(5000, 9000), 0.6, rnd(0.008, 0.018)); }, k * rnd(40, 90)); })(i);
    }
  }
  function chirp(up) {
    if (!on || !ensure()) return;
    tone(up ? 440 : 880, up ? 880 : 440, 0.09, 'triangle', 0.03);
    setTimeout(function () { if (ctx) tone(up ? 660 : 660, up ? 1320 : 330, 0.08, 'triangle', 0.022); }, 90);
  }

  /* kaching: a little register thud + two bright coin rings. present but not loud. */
  function kaching() {
    if (!on || !ensure()) return;
    tone(220, 70, 0.12, 'triangle', 0.03);
    noise(0.05, 'highpass', 2500, 7000, 0.8, 0.028);
    setTimeout(function () {
      if (!ctx) return;
      tone(1568, 1568, 0.32, 'sine', 0.03);
      tone(3136, 3136, 0.2, 'sine', 0.01);
    }, 95);
    setTimeout(function () {
      if (!ctx) return;
      tone(2093, 2093, 0.7, 'sine', 0.032);
      tone(4186, 4186, 0.45, 'sine', 0.011);
      tone(2637, 2637, 0.5, 'sine', 0.014);
    }, 200);
  }

  /* crumble: soft static falling away, for the little messages */
  function crumble() {
    if (!on || !ensure()) return;
    noise(0.35, 'bandpass', 3200, 500, 0.8, 0.02);
    tone(700, 180, 0.3, 'triangle', 0.012);
    for (var i = 0; i < 4; i++) {
      (function (k) { setTimeout(function () { if (on && ctx) noise(rnd(0.03, 0.06), 'highpass', rnd(3000, 5000), rnd(5000, 8000), 0.6, rnd(0.006, 0.012)); }, 60 + k * rnd(60, 110)); })(i);
    }
  }
  window.glSfx = { kaching: kaching, crumble: crumble };
  window.glSoundOn = function () { return on; };

  /* on/off button (desktop only: on a phone the sound button is just the one in the intro) */
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'gl-sound';
  var st = document.createElement('style');
  st.textContent =
    '.gl-sound{position:fixed;left:14px;bottom:14px;z-index:9999;padding:.7rem 1.1rem;font:inherit;font-size:1.2rem;letter-spacing:.14em;text-transform:lowercase;color:#f2efff;background:rgba(10,10,16,.85);border:1px solid rgba(34,230,255,.7);cursor:pointer}' +
    '.gl-sound:hover{box-shadow:-2px 0 0 #22e6ff,2px 0 0 #ff2fd0}' +
    '.gl-sound[aria-pressed=true]{border-color:#ff2fd0}' +
    '@media (max-width:749px){.gl-sound{display:none!important}}';
  document.head.appendChild(st);
  var hero = null;
  function btns() { return [btn].concat(Array.prototype.slice.call(document.querySelectorAll('[data-gl-sound]'))); }
  function paint() {
    btns().forEach(function (b) {
      b.textContent = on ? 'sound: on' : 'sound: off';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'turn sound off' : 'turn sound on');
    });
  }
  function toggle(e) {
    e.stopPropagation();
    autoOn = false;
    on = !on;
    save(on);
    paint();
    if (on) { unlockPhone(); ensure(); chirp(true); } else { lullPhone(); if (ctx) ctx.suspend(); }
  }
  paint();
  btn.addEventListener('click', toggle);
  function findHero() {
    if (hero) return;
    hero = document.querySelector('[data-gl-sound]');
    if (!hero) return;
    hero.addEventListener('click', toggle);
    paint();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        btn.style.display = en[0].isIntersecting ? 'none' : '';
      }).observe(hero);
    }
  }
  function mount() { if (document.body && !btn.parentNode) document.body.appendChild(btn); findHero(); }
  mount();
  document.addEventListener('DOMContentLoaded', mount);

  /* tap, click or key press: a returning visitor with sound on gets audio unlocked; a first-time visitor gets sound switched on (and remembered).
     phones only unlock audio from a real touch and can put it back to sleep, so this keeps retrying until the audio is actually running */
  var GESTURES = ['pointerdown', 'pointerup', 'touchstart', 'touchend', 'click', 'keydown'];
  function firstGesture(e) {
    var tg = e && e.target && e.target.closest ? e.target : null;
    if (tg && tg.closest('.gl-sound, [data-gl-sound]')) return;
    if (!on && autoOn) {
      autoOn = false;
      on = true;
      save(true);
      paint();
      unlockPhone();
      ensure();
      chirp(true);
    } else if (on) {
      unlockPhone();
      ensure();
    }
    if (!on && !autoOn) { GESTURES.forEach(function (t) { document.removeEventListener(t, firstGesture, true); }); return; }
    if (ctx && ctx.state === 'running' && e && (e.type === 'click' || e.type === 'touchend' || e.type === 'keydown')) {
      GESTURES.forEach(function (t) { document.removeEventListener(t, firstGesture, true); });
    }
  }
  GESTURES.forEach(function (t) { document.addEventListener(t, firstGesture, true); });
  /* coming back to the tab or app: wake the audio again */
  document.addEventListener('visibilitychange', function () { if (!document.hidden && on && ctx && ctx.state !== 'running' && ctx.state !== 'closed') ctx.resume(); });

  /* click sound (the golden cat gets its own) */
  document.addEventListener('click', function (e) {
    var tg = e.target && e.target.closest ? e.target : null;
    if (tg && tg.closest('.gl-sound, [data-gl-sound]')) return;
    if (tg && tg.closest('.gl-gcat')) { kaching(); return; }
    click();
  }, true);

  /* cursor swish: barely there, once in a while as the mouse travels */
  var lx = null, ly = null, dist = 0, lastT = 0, lastS = 0;
  window.addEventListener('mousemove', function (e) {
    if (!on) { lx = null; return; }
    var now = performance.now();
    if (lx === null) { lx = e.clientX; ly = e.clientY; lastT = now; return; }
    var dx = e.clientX - lx, dy = e.clientY - ly;
    lx = e.clientX; ly = e.clientY;
    dist += Math.sqrt(dx * dx + dy * dy);
    var dt = Math.max(1, now - lastT);
    lastT = now;
    if (dist >= 300 && now - lastS > 260) {
      var speed = Math.min(2.5, dist / dt);
      swish(0.0012 + Math.min(0.0018, speed * 0.0008));
      dist = 0; lastS = now;
    }
  }, { passive: true });

  /* now and then: static or a blip */
  function ambient() {
    if (on && !document.hidden && ctx && ctx.state === 'running') { if (Math.random() < 0.55) stat(); else blip(); }
    setTimeout(ambient, rnd(6000, 15000));
  }
  setTimeout(ambient, 7000);
})();